import { NestApiProvider } from "../../nest-api";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ResponseAddDto, ResponseCompanySettingDto, RequestUpdatePost } from "../dto/on-duty-declaration.dto";

@Injectable()
export class OnDutyDeclarationApi {
  private readonly service: string = '';
  private readonly model: string = 'sf6s/ondutyDeclaration';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public add(payload: any): Observable<ResponseAddDto> {
    const method: string = 'POST';
    const func: string = 'add';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseAddDto>(method, url, params, urlParams, body);
  }

  public save(payload: any): Observable<ResponseAddDto> {
    const method: string = 'POST';
    const func: string = 'save';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseAddDto>(method, url, params, urlParams, body);
  }

  public delete(payload: any): Observable<ResponseAddDto> {
    const method: string = 'POST';
    const func: string = 'delete';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseAddDto>(method, url, params, urlParams, body);
  }

  public companySetting(): Observable<ResponseCompanySettingDto> {
    const method: string = 'GET';
    const func: string = 'companySetting';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseCompanySettingDto>(method, url, func, params, body);
  }

  public updatePost(fileName: string, requestNo: string): Observable<RequestUpdatePost> {
    const method: string = 'POST';
    const func: string = 'updatePost';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof fileName !== 'undefined' && fileName !== null) urlParams.fileName = fileName;
    if (typeof requestNo !== 'undefined' && requestNo !== null) urlParams.requestNo = requestNo;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public feedDeclaration(requestNo: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'feedDeclaration';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof requestNo !== 'undefined' && requestNo !== null) urlParams.requestNo = requestNo;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }
}


// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-integrated/services/on-duty-declaration.api.ts